import { StoryblokComponent, storyblokEditable } from '@storyblok/react'
import { StoryblokStory } from 'storyblok-generate-ts'
import { CTA, Container, HandLeftIcon, Link, Logo } from '~/components'
import { PageStoryblok } from '~/storyblok'

import * as styles from './Page.css'

type Props = {
  story: StoryblokStory<PageStoryblok>
}

export function Page({ story }: Props) {
  return (
    <div>
      <Container>
        <div css={styles.header}>
          <div css={styles.headerBrand}>
            <Link href="/">
              <Logo css={styles.logo} />
            </Link>
          </div>
          <div css={styles.headerAction}>
            <CTA href="/" icon={<HandLeftIcon css={styles.actionIcon} />} css={styles.actionButton}>
              zurück zur Übersicht
            </CTA>
          </div>
        </div>
      </Container>

      {story.content.blocks?.map((blok) => (
        <div key={blok._uid} {...storyblokEditable(blok)}>
          <StoryblokComponent blok={blok} />
        </div>
      ))}

      <br />
      <br />
      <br />
    </div>
  )
}
